import React from 'react';
import { RiLightbulbFlashLine } from 'react-icons/ri';
import { INSIGHT_META } from './constants';
import { humanizeSnakeCaseText } from './formatters';

const ChatInsights = ({ insights }) => (
    <section className="ai-chat-section ai-chat-insights">
        <h6><RiLightbulbFlashLine /> Insights</h6>
        <div className="ai-chat-insight-list">
            {insights.map((insight, index) => {
                const meta = INSIGHT_META[insight && insight.type] || INSIGHT_META.general;
                return (
                    <article
                        className="ai-chat-insight"
                        key={`${insight && insight.title}-${index}`}
                        style={{ '--ai-chat-insight-color': meta.color }}
                    >
                        <div className="ai-chat-insight-heading">
                            <strong>
                                {humanizeSnakeCaseText((insight && insight.title) || 'Insight')}
                            </strong>
                            <span>{meta.label}</span>
                        </div>
                        <p>{humanizeSnakeCaseText((insight && insight.explanation) || '')}</p>
                    </article>
                );
            })}
        </div>
    </section>
);

export default ChatInsights;
